module.exports = __webpack_public_path__ + "img/logo.65ff4439.png";